import User from '@/auth/User';

const user = new User(JSON.parse(localStorage.getItem('auth.user')));

function login(code) {
  return user.login(code)
    .then(() => localStorage.setItem('auth.user', JSON.stringify(user)));
}

function logout() {
  user.logout();
  localStorage.removeItem('auth.user');
  window.location.reload();
}

function isLoggedIn() {
  return user.isLoggedIn;
}

function getToken() {
  return user.accessToken;
}

export {
  login,
  logout,
  isLoggedIn,
  getToken,
};



// WEBPACK FOOTER //
// ./src/auth/index.js